// The `temporal-polyfill/global` import overwrites browser implementations so
// we need to manually add it to prevent this.
// See: https://github.com/fullcalendar/temporal-polyfill/issues/71
import { Temporal as BaseTemporal, toTemporalInstant } from "temporal-polyfill";

/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
-- Extending for polyfilling requires ignoring the otherwise reasonable warnings. */
(globalThis as any).Temporal ??= BaseTemporal;
(Date.prototype as any).toTemporalInstant ??= toTemporalInstant;
/* eslint-enable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any */

declare global {
	const Temporal: typeof BaseTemporal;
	/* eslint-disable-next-line @typescript-eslint/no-namespace
	-- This is the only way to actually define this existing library. */
	namespace Temporal {
		// Namespaces can't be directly re-exported (as of TS 5.3) so we have to
		// redefine each type in a new namespace until the polyfill itself loads
		// directly into the global space.
		type Duration = BaseTemporal.Duration;
		type Instant = BaseTemporal.Instant;
		type PlainDate = BaseTemporal.PlainDate;
		type PlainDateTime = BaseTemporal.PlainDateTime;
		type PlainMonthDay = BaseTemporal.PlainMonthDay;
		type PlainTime = BaseTemporal.PlainTime;
		type PlainYearMonth = BaseTemporal.PlainYearMonth;
		type ZonedDateTime = BaseTemporal.ZonedDateTime;
	}
	interface Date {
		readonly toTemporalInstant: typeof toTemporalInstant;
	}
}
